import React from 'react';
import { FixedSizeList as List } from 'react-window';
import Badge from '../../common/Badge';
import '../../../styles/Auction.css';

const ROW_HEIGHT = 70;
const LIST_HEIGHT = 380;

const BidRow = React.memo(({ index, style, data }) => {
    const bid = data[index];
    const isTopBid = index === 0;

    return (
        <div style={{ ...style, padding: '4px 0' }}>
            <div className={`bid-history-row ${isTopBid ? 'top-bid-row' : ''}`} style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.75rem 1rem',
                borderRadius: 'var(--radius-md, 10px)',
                background: isTopBid 
                    ? 'linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(56, 189, 248, 0.08))' 
                    : 'var(--bg-surface, #0f1117)',
                border: isTopBid 
                    ? '1px solid rgba(99, 102, 241, 0.3)' 
                    : '1px solid var(--border-hairline, rgba(255, 255, 255, 0.08))',
                transition: 'all 0.2s ease',
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span className="bid-user" style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                            {bid?.bidder_id ? `Collector #${String(bid.bidder_id).slice(-4)}` : 'Anonymous'}
                        </span>
                        {isTopBid && (
                            <Badge variant="live" size="sm">
                                LEADER
                            </Badge>
                        )}
                    </div>
                    <span className="bid-time tabular-nums" style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>
                        {new Date(bid?.timestamp || bid?.created_at || Date.now()).toLocaleTimeString()}
                    </span>
                </div>
                <div className="bid-amount tabular-nums" style={{
                    fontFamily: 'var(--font-mono)',
                    fontWeight: 700,
                    fontSize: '1.15rem',
                    color: isTopBid ? 'var(--accent-cyan, #38bdf8)' : 'var(--text-primary)',
                }}>
                    ${parseFloat(bid?.amount || 0).toLocaleString()}
                </div>
            </div>
        </div>
    );
});

const BidHistory = ({ bids }) => {
    return (
        <div className="bid-history">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                <h3 style={{ margin: 0 }}>Bid History</h3>
                {bids && bids.length > 0 && (
                    <span className="tabular-nums font-mono" style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                        {bids.length} {bids.length === 1 ? 'bid' : 'bids'}
                    </span>
                )}
            </div>

            {!bids || bids.length === 0 ? (
                <p className="no-bids">No bids yet placed in this session.</p>
            ) : (
                <List
                    className="bid-history-list"
                    height={LIST_HEIGHT}
                    itemCount={bids.length}
                    itemSize={ROW_HEIGHT}
                    width="100%"
                    itemData={bids}
                >
                    {BidRow}
                </List>
            )}
        </div>
    );
};

export default BidHistory;